import {Form, Input} from "antd";
import {GetFieldDecoratorOptions} from "antd/lib/form/Form";
import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import {nameof} from "src/core/utils/object";
import {TooltipItem} from "../../stores/tooltips-store";
import RichTextView from "../../core/ui/form/rich-editor.view";

let FormItem = Form.Item;

interface TooltipFormProps extends WithTranslation {
    item: TooltipItem | undefined;
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(
        id: keyof T,
        options?: GetFieldDecoratorOptions
    ): (node: React.ReactNode) => React.ReactNode;
}

export class TooltipForm extends React.Component<TooltipFormProps> {
    render() {
        const { t } = this.props;
        const { TextArea } = Input

        var tooltipItem = this.props.item || ({} as TooltipItem);
        return (
            <FormItem label={t("Insert text for this tooltip")}>
                {this.props.getFieldDecorator(nameof<TooltipItem>("text"), {
                    initialValue: tooltipItem.text,
                    rules: [{ required: true, message: t("Text required") }],
                })(
                    <RichTextView value={tooltipItem.text}/>
                )}
            </FormItem>
        );
    }
}

export default withTranslation()(TooltipForm);
